var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H3v.005A1.995 1.995 0 001.005 3h.005v12h-.005c0 1.102.893 1.995 1.995 1.995v-.005h12v.005A1.995 1.995 0 0016.995 15H17V3h-.005A1.995 1.995 0 0015 1.005V1zm0-.01v.005c1.107 0 2.005.898 2.005 2.005h.005v12h-.005A2.005 2.005 0 0115 17.005V17H3v.005A2.005 2.005 0 01.995 15H1V3H.995C.995 1.893 1.893.995 3 .995V.99h12zm0 1.51H3v.005A.495.495 0 002.505 3h.005v12h-.005c0 .273.222.495.495.495v-.005h12v.005a.495.495 0 00.495-.495h.005V3h-.005A.495.495 0 0015 2.505V2.5zm0-.01v.005c.279 0 .505.226.505.505h.005v12h-.005a.505.505 0 01-.505.505V15.5H3v.005A.505.505 0 012.495 15H2.5V3h-.005c0-.279.226-.505.505-.505V2.49h12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1h12v.005c1.102 0 1.995.893 1.995 1.995H17v12h-.005A1.995 1.995 0 0115 16.995v-.005H3v.005A1.995 1.995 0 011.005 15h.005V3h-.005c0-1.102.893-1.995 1.995-1.995V1zm12 1.49v.005c.279 0 .505.226.505.505h.005v12h-.005a.505.505 0 01-.505.505V15.5H3v.005A.505.505 0 012.495 15H2.5V3h-.005c0-.279.226-.505.505-.505V2.49h12z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.7c64e235.svg";
export { ForwardRef as ReactComponent };